import { render } from "./ReachToLimitModal.vue?vue&type=template&id=38d2decc"
import script from "./ReachToLimitModal.vue?vue&type=script&lang=js"
export * from "./ReachToLimitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__